import React, { Component } from 'react'
import ApiGateway from '../helper/ApiGateway';
import ERPUtils from '../helper/Utils';
import moment from "moment";
import bibtexParse from 'bibtex-parse-js';
import ReactDOM from 'react-dom';

export default class OrcidPopup extends Component {
    constructor(props) {
        super(props);
        this.containerEl = document.createElement('div');
        this.externalWindow = null;
        this.state = {
            orcidID: "",
            openWorks: false,
            openEducationalQualification: false,
            openEmployment: false,
            errorMessage: "",
            data: this.getDefaultStateData()
        }
    }
    getDefaultStateData = () => {
        return {
            works: [],
        }
    }
    componentDidMount() {
        let title = 'Orcid Details - ' + this.props.orcidId;
        var loadingHtml = '<div class="app-ui-loader" id="newWindow" style="position:absolute;z-index: 5001;top:0px;left:0px;background-color: rgba(0,0,0,.1);width: 100%;height: 100%;">'
            + '<div style="position:absolute;width: 70px;height: 70px;border-radius: 35px;background-color: #F5F5F5;left: 50%;top: 50%;margin-top:  -35px;margin-left: -35px;">'
            + '<svg class="lds-curve-bars" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><g transform="translate(50,50)"><circle cx="0" cy="0" r="8.333333333333334" fill="none" stroke="#0051a2" stroke-width="5" stroke-dasharray="26.179938779914945 26.179938779914945" transform="rotate(222.749)">'
            + '<animateTransform attributeName="transform" type="rotate" values="0 0 0;360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="0" repeatCount="indefinite"></animateTransform>'
            + '</circle><circle cx="0" cy="0" r="16.666666666666668" fill="none" stroke="#1b75be" stroke-width="5" stroke-dasharray="52.35987755982989 52.35987755982989" transform="rotate(306.782)">'
            + '<animateTransform attributeName="transform" type="rotate" values="0 0 0;360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="-0.2" repeatCount="indefinite"></animateTransform>'
            + '</circle><circle cx="0" cy="0" r="25" fill="none" stroke="#408ee0" stroke-width="5" stroke-dasharray="78.53981633974483 78.53981633974483" transform="rotate(359.939)">'
            + '<animateTransform attributeName="transform" type="rotate" values="0 0 0;360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="-0.4" repeatCount="indefinite"></animateTransform>'
            + '</circle><circle cx="0" cy="0" r="33.333333333333336" fill="none" stroke="#89bff8" stroke-width="5" stroke-dasharray="104.71975511965978 104.71975511965978" transform="rotate(49.7418)">'
            + '<animateTransform attributeName="transform" type="rotate" values="0 0 0;360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="-0.6" repeatCount="indefinite"></animateTransform>'
            + '</circle><circle cx="0" cy="0" r="41.666666666666664" fill="none" stroke="#e3f1ff" stroke-width="5" stroke-dasharray="130.89969389957471 130.89969389957471" transform="rotate(133.175)">'
            + '<animateTransform attributeName="transform" type="rotate" values="0 0 0;360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="-0.8" repeatCount="indefinite"></animateTransform>'
            + '</circle></g>'
            + '</svg>'
            + '</div>'
            + '</div>';
        this.externalWindow = window.open('', title, 'width=800,height=600,left=200,top=200');
        if (this.externalWindow) {
            this.externalWindow.document.write('<html><head><title>' + title + '</title>');
            this.externalWindow.document.write('<link href="contents/plugins/fontawesome-free/css/all.min.css" rel="stylesheet" />');
            this.externalWindow.document.write('<link href="contents/plugins/bootstrap/bootstrap.css" rel="stylesheet" />');
            this.externalWindow.document.write('<link href="https://code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" rel="stylesheet" />');
            this.externalWindow.document.write('<link href="contents/plugins/admin-lte/adminlte.css" rel="stylesheet" />');
            this.externalWindow.document.write('<link href="contents/plugins/admin-lte/_all-skins.css" rel="stylesheet" />');
            this.externalWindow.document.write('<link href="contents/plugins/iCheck/square/blue.css" rel="stylesheet" />');
            this.externalWindow.document.write('<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,600,700,300italic,400italic,600italic"  />');
            this.externalWindow.document.write('<link href="contents/styles/OrcidPopUp.css" rel="stylesheet" />');
            this.externalWindow.document.write('</head><body style = "font-size:14px">');
            this.externalWindow.document.write(loadingHtml);
            this.externalWindow.document.write('</body></html>');
            this.externalWindow.document.body.appendChild(this.containerEl);
            this.externalWindow.addEventListener('beforeunload', () => {
                this.props.closeWindowPortal();
            });
            this.externalWindow.document.close();
        }
        let orcidID = this.props.orcidId;
        const newState = this.state;
        newState.orcidID = orcidID;
        this.setState(newState);
        this.onInitData();
        this.props.updateId();
    }
    componentWillUnmount() {
        if (this.externalWindow) {
            this.externalWindow.close();
        }
    }
    UNSAFE_componentWillReceiveProps(props) {
        if (props.updateIdValue && this.externalWindow) {
            this.externalWindow.focus();
            let orcidID = props.orcidId;
            const newState = this.state;
            newState.orcidID = orcidID;
            this.setState(newState);
            var element = this.externalWindow.document.getElementById("newWindow");
            element.style.visibility = "visible";
            this.onInitData();
            props.updateId();
        }
    }
    onInitData = () => {
        try {
            if (ERPUtils.isNullorWhiteSpace(this.state.orcidID) === false) {
                ApiGateway.getOrcidData(this.state.orcidID + "/works", response => {
                    try {
                        if (!ERPUtils.isUndefinedOrNull(response.data) === true) {
                            this.getWorksData(response.data.group);
                        }
                    } catch (ex) { }
                });
            }
        }
        catch (ex) { }
    }
    getWorksData = (data) => {
        if (data.length === 0) {
            this.setState({ errorMessage: "No Public Information Available" });
        }
        let works = [];
        var publicationName = "";
        var publicationYear = "";
        var doiReference = "";
        var source = "";
        var createdDate = "";
        var lastModifedDate = "";
        var publicationDate = "";
        for (var i in data) {
            if (data[i]["work-summary"]["0"].title.title.value != null) {
                publicationName = data[i]["work-summary"]["0"].title.title.value;
            }
            if (data[i]["work-summary"]["0"].type != null) {
                var paperType = data[i]["work-summary"]["0"].type;
                paperType = paperType.toLowerCase().replace("_", "-");
            }
            if (data[i]["work-summary"]["0"]["publication-date"] != null) {
                publicationYear = data[i]["work-summary"]["0"]["publication-date"].year.value;
            }
            if (data[i]["work-summary"]["0"]["publication-date"].month != null) {
                publicationDate = publicationYear + "-";
                publicationDate += data[i]["work-summary"]["0"]["publication-date"].month.value;
            }
            if (data[i]["work-summary"]["0"]["publication-date"].day != null) {
                publicationDate += "-" + data[i]["work-summary"]["0"]["publication-date"].day.value;
            }
            else {
                publicationDate = publicationYear;
            }
            if (data[i]["external-ids"]["external-id"]["length"] !== 0) {
                for (var j in data[i]["external-ids"]["external-id"]) {
                    if (data[i]["external-ids"]["external-id"][j]["external-id-type"] === 'doi') {
                        doiReference = data[i]["external-ids"]["external-id"][j]["external-id-value"];
                        break;
                    }
                }
            }
            if (!ERPUtils.isNullOrEmpty(data[i]["work-summary"]["0"].source)) {
                source = data[i]["work-summary"]["0"].source["source-name"].value;
            }
            if (!ERPUtils.isNullOrEmpty(data[i]["work-summary"]["0"]["created-date"])) {
                var date = new Date(data[i]["work-summary"]["0"]["created-date"].value);
                createdDate = moment(date.toISOString(), 'YYYY-MM-DD').format("YYYY-MM-DD");
            }
            if (!ERPUtils.isNullOrEmpty(data[i]["work-summary"]["0"]["last-modified-date"])) {
                date = new Date(data[i]["work-summary"]["0"]["last-modified-date"].value);
                lastModifedDate = moment(date.toISOString(), 'YYYY-MM-DD').format("YYYY-MM-DD");
            }
            var putcode = data[i]["work-summary"]["0"]["put-code"];
            this.getOtherInfo(putcode, i);
            works.push({
                publicationName: publicationName,
                publicationYear: publicationYear,
                publicationDate: publicationDate,
                doiReference: doiReference,
                paperType: paperType,
                source: source,
                createdDate: createdDate,
                lastModifedDate: lastModifedDate,
                showOtherInfo: false,
                otherInfo: {}
            })
            this.setState({ data: { ...this.state.data, works: works } });
        }
        var element = this.externalWindow.document.getElementById("newWindow");
        element.style.visibility = "hidden";
        this.externalWindow.document.title = 'Orcid Details - ' + this.state.orcidID;
    }
    getOtherInfo = (journalID, i) => {
        ApiGateway.getOrcidData(this.state.orcidID + "/work/" + journalID, response => {
            try {
                var journal = "";
                if (!ERPUtils.isUndefinedOrNull(response.data.citation) === true) {
                    var otherInfoData = bibtexParse.toJSON(response.data.citation["citation-value"]);
                    if (!ERPUtils.isUndefinedOrNull(response.data["journal-title"])) {
                        journal = response.data["journal-title"].value;
                    }
                    const newState = this.state.data.works;
                    newState[i].otherInfo = otherInfoData[0].entryTags;
                    if (ERPUtils.isUndefinedOrNull(newState[i].otherInfo.journal) && !ERPUtils.isNullorWhiteSpace(journal) && ERPUtils.isUndefinedOrNull(newState[i].otherInfo.booktitle)) {
                        newState[i].otherInfo.journal = journal;
                    }
                    this.setState({ data: { ...this.state.data, works: newState } });
                }
            } catch (ex) { }
        });
    }
    toggleWorks(e) {
        const newState = this.state.data.works;
        newState[e.currentTarget.id].showOtherInfo = !newState[e.currentTarget.id].showOtherInfo;
        this.setState({ data: { ...this.state.data, works: newState } });
    }
    onClose = () => {
        if (this.externalWindow) {
            this.externalWindow.close();
        }
    };
    render() {
        return ReactDOM.createPortal(
            <div style={{ padding: "5px", fontFamily: 'inherit' }}>
                {this.state.data.works.length > 0 ? (
                    <div style={{ borderBottom: "1px solid #ccc", paddingLeft: "7px", paddingRight: "7px" }}>
                        {this.state.data.works.map((work, index) => (
                            <div style={{
                                border: "1px solid #c9cacb", display: "block",
                                padding: "10px 15px",
                                boxShadow: "3px 4px 5px #c9cacb",
                                marginTop: "15px", borderRadius: '5px'
                            }} key={index}>
                                <div id={index} onClick={(e) => this.toggleWorks(e)} >
                                    <label style={{ width: "96%" }}>{work.publicationName}</label>
                                    <span style={{ float: "right", position: "absolute", fontSize: '25px' }} >
                                        {!work.showOtherInfo ? (<i className="fas fa-chevron-circle-down icon-background" ></i>) : (<i className="fas fa-chevron-circle-up icon-background"></i>)}
                                    </span>
                                </div>
                                {(!ERPUtils.isNullorWhiteSpace(work.otherInfo.journal) && <><label style={{ fontWeight: 'normal' }}>{work.otherInfo.journal}</label><br /></>) ||
                                    (!ERPUtils.isNullorWhiteSpace(work.otherInfo.booktitle) && <><label style={{ fontWeight: 'normal' }}>{work.otherInfo.booktitle}</label><br /></>)}
                                <label style={{ fontWeight: 'normal' }}>{work.publicationDate}</label>
                                <label style={{ fontWeight: 'normal' }}> &nbsp;| {work.paperType}</label><br />
                                {!ERPUtils.isNullorWhiteSpace(work.doiReference) && <><label> DOI: <a href={`https://doi.org/${work.doiReference}`} target="_blank" rel="noopener noreferrer">
                                    {work.doiReference}</a></label><br /></>
                                }
                                {work.showOtherInfo &&
                                    <div>
                                        <hr />
                                        <label>Citation</label>
                                        <table>
                                            <tbody>
                                                {
                                                    Object.keys(work.otherInfo).map((key, index) => (
                                                        <tr key={index}>
                                                            <td><label style={{ fontSize: "14px", fontWeight: 'normal' }}>{key.charAt(0).toUpperCase() + key.slice(1)}</label></td>
                                                            <td style={{ paddingLeft: "5px" }}><label style={{ fontSize: "14px", fontWeight: 'normal' }}>{work.otherInfo[key]}</label></td>
                                                        </tr>
                                                    ))
                                                }
                                                <tr>
                                                    <td>
                                                        <br />
                                                    </td>
                                                </tr>
                                                {!ERPUtils.isNullorWhiteSpace(work.createdDate) && <tr>
                                                    <td>
                                                        <label style={{ fontSize: "14px", fontWeight: 'normal' }} >Added<br />{work.createdDate}</label>
                                                    </td>
                                                    <td>
                                                        <label style={{ paddingLeft: "200px", fontSize: '14px', fontWeight: 'normal' }}>Last Modified<br />{work.lastModifedDate}</label></td>
                                                </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>}
                                <label style={{ fontWeight: 'normal' }}>Source: {work.source}</label>
                            </div>
                        ))
                        }
                        <div style={{ padding: "5px", paddingBottom: "2px", display: "inline-block", width: "100%", border: "1px solid #ccc" }}>
                            <div>
                                <button token="close" onClick={this.onClose} className="btn btn-danger btn-md" style={{ display: "block", margin: "0 auto", width: "15%" }} >Close</button>
                            </div>
                        </div>
                    </div>
                ) : (<label className="noWorks">{this.state.errorMessage}</label>)
                }
            </div>, this.containerEl
        );
    }
}